// export const phoneRegExp = /^((\+[1-9]{1,4}[ -]?)|(\([0-9]{2,3}\)[ -]?)|([0-9]{2,4})[ -]?)*?[0-9]{3,4}[ -]?[0-9]{3,4}$/
export const phoneRegExp = /^\+?(972|0)(\-)?0?(([23489]{1}\d{7})|[5]{1}\d{8})$/
export const zipRegExp = /^[0-9]{5}(?:-[0-9]{4})?$/
export const onlyNumbersRegExp = /^[0-9]/
export const notZeroesRegExp = /^(?!.*(0000000).*$)/
export const onlyEnglishAndHebrewAndSpace = /^[\u0590-\u05FF\uFB1D-\uFB4F\u05D0-\u05EAa-zA-Z\s]+$/
export const onlyEnglishAndSpace = /^[A-Za-z\s]+$/